import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-recommend-form__field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "配偶者"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)
const _hoisted_3 = { class: "p-recommend-form__error-wrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "配偶者", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "配偶者の扶養義務", -1)
const _hoisted_6 = { class: "p-recommend-form__group-1-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "扶養家族（配偶者を除く）", -1)
const _hoisted_8 = { class: "p-recommend-form__group-1-field-set-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "人", -1)

import InvalidMessage from '@/components/InvalidMessage.vue';
import ValidatableField from '@/components/ValidatableField.vue';
import ResumeSelect from '../components/ResumeSelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpouseInfoForm',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(InvalidMessage, { name: "dependentsNum" })
    ]),
    _hoisted_4,
    _createVNode(ResumeSelect, {
      name: "spousePresenceFlg",
      label: "選択",
      id: "spousePresence",
      className: "p-recommend-form__select"
    }),
    _hoisted_5,
    _createVNode(ResumeSelect, {
      name: "spouseObligationFlg",
      label: "選択",
      id: "spouseObligation",
      className: "p-recommend-form__select"
    }),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(ValidatableField, {
          class: "p-recommend-form__modal-input-2",
          id: "form-dependent-number",
          type: "text",
          name: "dependentsNum",
          placeholder: "0",
          label: "扶養家族（配偶者を除く）",
          rules: "numeric|max:2",
          maxlength: "2"
        }),
        _hoisted_9
      ])
    ])
  ]))
}
}

})